// extracted by mini-css-extract-plugin
export default {"container":"Projects_container__4EA60","first-project":"Projects_first-project__Jun76","second-project":"Projects_second-project__b6SbV"};